export interface ContactGroupBindContactsPayloadModel {
  emailsUpdated: string[];
  invalidEmails: string[];
}
